import { render } from "./DashboardsTables.vue?vue&type=template&id=44fe3d9e&scoped=true&ts=true"
import script from "./DashboardsTables.vue?vue&type=script&lang=ts"
export * from "./DashboardsTables.vue?vue&type=script&lang=ts"

import "./DashboardsTables.vue?vue&type=style&index=0&id=44fe3d9e&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44fe3d9e"]])

export default __exports__